import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import {
  AggregateView,
  FiltersUsed,
  PaymentMethodView,
  RecordView,
  TableView,
  isAnyFilterExists,
} from "../_shared/DetailsPageView";
import clap_service_logo from "../../assets/images/clap-service-logo.png";
import tableUtils from "../../utils/tableUtils";
import { ClientAdjustmentColumn } from "../../shared/table/columns";
import {
  AccountType,
  Currency,
  InvoiceDefaultNotes,
} from "../../shared/constant";
import dateUtils from "../../utils/dateUtils";
import { RootState } from "../../redux/rootReducer";
import clapUtils, {
  isAccountsORManager,
  isClapAdminORClapManager,
} from "../../utils/clapUtils";

const InvoiceToPrint = React.forwardRef((props: any, ref: any) => {
  const {
    invoiceDetails,
    invoiceDues,
    invoiceCurrency,
    headerData,
    noPageclientAdjustments,
  } = props;

  // useEffect(() => {
  //   console.log("PROPS; ", invoiceDetails, noPageclientAdjustments);
  // }, []);

  const { userDetails } = useSelector((state: RootState) => state.user);

  const buildTableData = () => {
    const results = invoiceDues?.period_wise_amount?.map((dues: any) => {
      const period = Object.keys(dues)[0];
      if (isAccountsORManager(userDetails)) {
        if (
          invoiceDetails.client_details.client_types[0] === AccountType.LABEL
        ) {
          return {
            c1: period,
            c3: `${invoiceCurrency} ${dues[period].gross_amount}`,
            // c4: `${invoiceCurrency} ${dues[period].payable_amount}`,
          };
        }
        if (
          invoiceDetails.client_details.client_types[0] === AccountType.MEMBER
        ) {
          return {
            c1: period,
            // c3: `${invoiceCurrency} ${dues[period].gross_amount}`,
            c4: `${invoiceCurrency} ${dues[period].payable_amount}`,
          };
        }
      }
      return {
        c1: period,
        c3: `${invoiceCurrency} ${dues[period].gross_amount}`,
        c4: `${invoiceCurrency} ${dues[period].payable_amount}`,
      };
    });
    return results;
  };

  return (
    <div ref={ref}>
      <style>
        {`@page {
            margin: 56px;
          }`}
      </style>
      <div>
        <div className="flex justify-between gap-6">
          <div>
            <div className="mb-1.5 default-border">
              <img
                src={clap_service_logo}
                alt="CLAP service logo"
                width={138}
                height={138}
              />
            </div>
            <div className="font-semibold text-lg">CLAP Services Ltd</div>
            <div className="text-[13px] leading-4">
              <div>info@clap.services</div>
            </div>
          </div>
          <div className="font-semibold text-right">
            <div className="text-heading30">Invoice</div>
            <div className="text-lg pb-6">
              {invoiceDetails?.invoice.invoice_no}
            </div>
            <div className="text-[13px]">
              Invoice Amount ({invoiceDetails.display_currency})
            </div>
            <div className="text-lg">
              {invoiceCurrency} {invoiceDetails.invoice.invoice_amount}
            </div>
          </div>
        </div>
        <div className="my-5 flex justify-between items-center w-full">
          <div className="flex gap-12">
            <div className="max-w-lg">
              <RecordView
                title="Name:"
                text={invoiceDetails?.client_details.name}
              />
              <RecordView
                title="Phone:"
                text={invoiceDetails?.client_details.phone}
              />
              <RecordView
                title="Address:"
                text={invoiceDetails?.client_details.address}
              />
            </div>
          </div>
          <div>
            <RecordView
              title="Invoice Date:"
              text={dateUtils.defaultFormat(invoiceDetails?.created_at)}
            />
            {/* {invoiceDetails?.reference && (
              <RecordView title="Ref:" text={invoiceDetails?.reference} />
            )} */}
          </div>
        </div>
        <div>
          {isAnyFilterExists(invoiceDetails) && (
            <>
              <div className="font-semibold mb-2">Filters Used</div>
              <div className="default-border px-2 py-0.5">
                <FiltersUsed details={invoiceDetails} />
              </div>
            </>
          )}
          {!!invoiceDues.period_wise_amount.length && (
            <div className="mt-5">
              <div className="bg-platinum">
                <TableView {...headerData} twClass="pt-1" header />
                <div className="flash-border my-[5px]" />
              </div>
              {buildTableData().map((data: any) => (
                <div key={data.c1}>
                  <TableView {...data} />
                  <div className="flash-border my-[5px]" />
                </div>
              ))}
              {isClapAdminORClapManager(userDetails) && (
                <TableView
                  {...{
                    c1: "Total",
                    c3: `${invoiceCurrency} ${invoiceDues.total_gross_income}`,
                    c4: `${invoiceCurrency} ${invoiceDues.total_payable}`,
                  }}
                  twClass="mt-[5px]"
                  header
                />
              )}
              {isAccountsORManager(userDetails) && (
                <>
                  {invoiceDetails.client_details.client_types[0] ===
                    AccountType.LABEL && (
                    <TableView
                      {...{
                        c1: "Total",
                        c3: `${invoiceCurrency} ${invoiceDues.total_gross_income}`,
                        // c4: `${invoiceCurrency} ${invoiceDues.total_payable}`,
                      }}
                      twClass="mt-[5px]"
                      header
                    />
                  )}
                  {invoiceDetails.client_details.client_types[0] ===
                    AccountType.MEMBER && (
                    <TableView
                      {...{
                        c1: "Total",
                        // c3: `${invoiceCurrency} ${invoiceDues.total_gross_income}`,
                        c4: `${invoiceCurrency} ${invoiceDues.total_payable}`,
                      }}
                      twClass="mt-[5px]"
                      header
                    />
                  )}
                </>
              )}
              {invoiceDues.exchange_rate && (
                <>
                  <TableView
                    {...{
                      c1: `Exchange rate on:  ${dateUtils.defaultFormat(
                        invoiceDetails.exchange_rate_added_at,
                      )}`,
                      c3: "Exchange Rate",
                      c4: invoiceDues.exchange_rate,
                    }}
                    twClass="mt-[5px]"
                  />
                  <AggregateView
                    title="Amount in BDT"
                    value={`${clapUtils.getCurrencyIcon(Currency.BDT)} ${
                      invoiceDues.amount_in_bdt
                    }`}
                    printView
                  />
                </>
              )}
            </div>
          )}
          {/* <AggregateView title="TAX" value="- 0.0" />
            <AggregateView title="Total Payment" value="€ 87.00" /> */}
        </div>
        {invoiceDetails.paid_date && (
          <div className="mt-12">
            <div className="flex gap-3">
              <div className="text-secondary">Payment Date: </div>
              <span>{invoiceDetails.paid_date}</span>
            </div>
            <PaymentMethodView details={invoiceDetails} printView />
          </div>
        )}
        {!!noPageclientAdjustments.length && (
          <div>
            <div className="font-semibold text-[15px] mt-10 mb-1">
              Advance Payment
            </div>
            <div>
              <Table
                rowKey={(record: any) => {
                  return record.id;
                }}
                columns={tableUtils.buildColumns(
                  noPageclientAdjustments,
                  ClientAdjustmentColumn,
                )}
                dataSource={noPageclientAdjustments}
                pagination={false}
                size="middle"
              />
            </div>
          </div>
        )}
        <div className="mt-7">
          <div className="font-medium">Notes</div>
          <div>{invoiceDetails.notes || InvoiceDefaultNotes}</div>
        </div>
      </div>
    </div>
  );
});

export default InvoiceToPrint;
